module.exports = __webpack_public_path__ + "static/media/motorcyk-motorcycle-ducati-profile-main.67e79778.jpg";